import getCookie from './getCookie'

const PDP_TEST_GROUP_COOKIE = 'PDP_Test_Group_1'

// eslint-disable-next-line no-unused-vars
export const isArgosTestVariant = cookies => {
  const testGroup = cookies?.[PDP_TEST_GROUP_COOKIE]
  const BRAND = process.env.BRAND || 'ARGOS'
  const isTestVariant = BRAND === 'ARGOS' && testGroup && testGroup === '2'

  return !!isTestVariant
}

export const isAlternativesBTest = () => {
  const testGroupCookie = getCookie(PDP_TEST_GROUP_COOKIE)
  const cookies = { [PDP_TEST_GROUP_COOKIE]: testGroupCookie }

  return isArgosTestVariant(cookies)
}

export const isInCategoryExperiencesGroup = (cookies, enabled, brand, breadcrumb) => {
  const testGroup = cookies?.[PDP_TEST_GROUP_COOKIE]
  const isInTestGroup = enabled && testGroup && testGroup === '2'
  const isInHabitatGroup = enabled && brand === 'HABITAT'
  const isInArgosGroup = isInTestGroup && brand === 'ARGOS' && breadcrumb[0]?.name === 'Home and furniture'
  return isInHabitatGroup || isInArgosGroup
}
